<script>
  import { BaseEdge, EdgeLabel } from "@xyflow/svelte";
  import * as d3 from "d3";

  export let data;
  export let markerEnd;
  $: points = data?.points || [];
  $: path = d3
    .line()
    .curve(d3.curveMonotoneY)
    .x((point) => point.x)
    .y((point) => point.y)(trimEdgePoints(points));
  $: labelPosition = data?.labelPosition || calculateLabelPosition(points);

  function calculateLabelPosition(edgePoints) {
    if (!edgePoints.length) return { x: 0, y: 0 };
    const middleIndex = Math.floor(edgePoints.length / 2);
    if (edgePoints.length % 2 === 0) {
      return {
        x: (edgePoints[middleIndex - 1].x + edgePoints[middleIndex].x) / 2,
        y: (edgePoints[middleIndex - 1].y + edgePoints[middleIndex].y) / 2,
      };
    }
    return edgePoints[middleIndex];
  }

  function trimEdgePoints(edgePoints) {
    if (!edgePoints || edgePoints.length < 2) return edgePoints;
    const trimmed = edgePoints.map((point) => ({ ...point }));
    trimPoint(trimmed[0], trimmed[1]);
    trimPoint(trimmed[trimmed.length - 1], trimmed[trimmed.length - 2]);
    return trimmed;
  }

  function trimPoint(point, neighbor) {
    const dx = neighbor.x - point.x;
    const dy = neighbor.y - point.y;
    const length = Math.hypot(dx, dy);
    if (!length) return;
    point.x += (dx / length) * 10;
    point.y += (dy / length) * 10;
  }
</script>

<BaseEdge
  {path}
  {markerEnd}
  style={data.playbackActive ? "stroke-width:3;stroke:#ff5f1f;" : "stroke-width:2;stroke:#626262;"}
/>
<EdgeLabel>
  <div
    class="edge-label"
    style:transform="translate(-50%, -50%) translate({labelPosition.x}px,{labelPosition.y}px)"
  >
    {data.label}
  </div>
</EdgeLabel>

<style>
  .edge-label {
    position: absolute;
    min-width: 38px;
    padding: 5px 9px;
    border: 1px solid #d6d6d6;
    border-radius: 999px;
    background: white;
    color: #24282d;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    white-space: nowrap;
    pointer-events: none;
  }

  :global(#case-id-preview-flow .svelte-flow__edgelabel-renderer) {
    z-index: 2;
  }

  :global(#case-id-preview-flow .svelte-flow__edges) {
    z-index: 1;
  }
</style>
